export class User {
    EmployeeId: number;
    UserId: number;
    CompanyId: number;
    FirstName: string;
    LastName1: string;
    LastName2: string;
    FullName: string;
    CURP: string;
    RFC: string;
    SessionToken: string;
    CreatedByUserId: number;
    CellPhoneNumber: string;
    PasswordHash: string;
    EmailAddress: string;
    Links: {
        SelfUri: string
    }
}



// WEBPACK FOOTER //
// C:/Users/LenninM/WebstormProjects/NomisignWebApp/src/app/models/user.model.ts